export var TemplateVerbs;
(function (TemplateVerbs) {
    TemplateVerbs["Create"] = "create";
    TemplateVerbs["Update"] = "update";
    TemplateVerbs["Duplicate"] = "duplicate";
    TemplateVerbs["Delete"] = "delete";
})(TemplateVerbs || (TemplateVerbs = {}));
